module.exports = __webpack_public_path__ + "img/fen2.26161e62.png";